export const servicePlanSubscriptionStatuses = {
  pending: {
    label: 'Pending',
    value: '0',
  },
  active: {
    label: 'Active',
    value: '1',
  },
  expiringSoon: {
    label: 'Expiring soon',
    value: '2',
  },
  expired: {
    label: 'Expired',
    value: '3',
  },
  cancelled: {
    label: 'Cancelled',
    value: '4',
  },
};

export const invoiceStatuses = {
  unsent: {
    label: 'Unsent',
    value: 0,
  },
  sent: {
    label: 'Sent',
    value: 1,
  },
  partiallyPaid: {
    label: 'Partially Paid',
    value: 2,
  },
  fullyPaid: {
    label: 'Fully Paid',
    value: 3,
  },
  uncollectible: {
    label: 'Uncollectible',
    value: 4,
  },
};

export const invoicePaymentMethodTypes = {
  cash: {
    label: 'Cash',
    value: 0,
  },
  check: {
    label: 'Check',
    value: 1,
  },
  card: {
    label: 'Card',
    value: 2,
  },
  other: {
    label: 'Other',
    value: 3,
  },
  credit: {
    label: 'Credit',
    value: 4,
  },
};

export const lineItemTypes = {
  material: {
    label: 'Material',
    value: 0,
  },
  service: {
    label: 'Service',
    value: 1,
  },
};

export const discountTypes = {
  fixed: '0',
  percent: '1',
};

export const depositAmountTypes = {
  percent: 0,
  fixed: 1,
};

export const estimateApprovalTypes = {
  notYetApproved: {
    label: 'Pending',
    value: 0,
    color: 'blue',
  },
  approved: {
    label: 'Approved',
    value: 1,
    color: 'green',
  },
  declined: {
    label: 'Declined',
    value: 2,
    color: 'red',
  },
};

export const ccSurchargeTypes = {
  Amount: {
    value: 0,
    label: 'Amount',
  },
  Percent: {
    value: 1,
    label: 'Percent',
  },
};

export const appointmentStatusLabels = {
  Scheduled: 'Scheduled',
  OnMyWay: 'On the way',
  Started: 'In progress',
  Finished: 'Finished',
};

export const paymentStatusValues = {
  unpaid: 0,
  pending: 1,
  paid: 2,
  failed: 3,
  voided: 4,
  refunded: 5,
};
